import { AxiosResponse } from "axios";
import { request } from "@utils";
import {
  PaginatedDescription,
  UnitsDescriptionRead,
  UnitDescriptionPayload,
  UnitsDescription,
} from "@types";

export const getAllUnitDescriptions = async (
  page?: number,
  withPagination: boolean = true,
): Promise<AxiosResponse<PaginatedDescription>> => {
  const req = request();

  if (withPagination) {
    return req.get<PaginatedDescription>(
      `/api/v1/unit-descriptions/paginated?page=${page ?? 1}&limit=10`,
    );
  }

  const res = await req.get<UnitsDescriptionRead[]>(
    `/api/v1/unit-descriptions`,
  );
  return {
    ...res,
    data: {
      data: res.data,
      totalCount: res.data.length,
      totalPages: 1,
    },
  };
};

export const getUnitsDescriptionByLocation = (
  locationId: string,
  page: number = 1,
  limit?: number,
): Promise<AxiosResponse<PaginatedDescription>> => {
  const req = request();
  if (limit === undefined) {
    return req.get(`/api/v1/locations/${locationId}/units`);
  }
  return req.get(
    `/api/v1/unit-descriptions/location/${locationId}?page=${page}&limit=${limit}`,
  );
};

export const createUnitDescription = async (
  data: UnitsDescription,
): Promise<UnitsDescriptionRead> => {
  const res = await request().post("/api/v1/unit-descriptions", data);
  return res.data;
};

export const updateUnitDescription = async (
  id: string,
  data: UnitDescriptionPayload,
): Promise<UnitsDescriptionRead> => {
  const res = await request().put(`/api/v1/unit-descriptions/${id}`, data);
  return res.data;
};

export const deleteUnitDescription = async (
  id: string,
): Promise<UnitsDescriptionRead> => {
  const res = await request().delete(`/api/v1/unit-descriptions/${id}`);
  return res.data;
};
